import { uniqBy } from 'lodash';
const encode = (value, opts) => {
  // Strictly encode URI components with strict is set to true
	if (opts.encode) {
		return opts.strict ? encodeURIComponent(decodeURIComponent(value)).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(decodeURIComponent(value));
	}

	return value;
};

/**
 * @func: Represents a tool to build object to query string.
 * @desc: This is a description of the buildQueryString function.
 * @param {object} params - Contain information about query string(affiliateno, resulttype, num, topic,...)
 * @param {object} options - Contain information about option (encode, strict)
 * @tutorial strict: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
 * @tutorial decode: https://www.w3schools.com/jsref/jsref_encodeURIComponent.asp
 */
const buildQueryString = (params, options = { encode: true, strict: true }, affiliateIds = []) => {
  let queryString = '';
  affiliateIds.push(params.affiliateno);
  params.affiliateno = uniqBy(affiliateIds).join();
  Object.keys(params).forEach(key => {
    if (params[key]) {
      queryString += (queryString.length ? '&' : '') + `${key}=`;
      queryString += encode(params[key], options);
    }
  });
  return queryString;
};

const buildNotFoundPageURL = (redirectUrl, destinationUrl = '/page-not-found') => {
  return `${destinationUrl}${redirectUrl ? `?url=${redirectUrl}` : ''}`;
};

export { buildQueryString, buildNotFoundPageURL };



// WEBPACK FOOTER //
// ./app/utils/UrlUtils.js